import React from "react";

interface BraveIconProps {
  className?: string;
  style?: React.CSSProperties;
}

export const BraveIcon: React.FC<BraveIconProps> = ({ className, style }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.68 0l2.096 2.38s1.84-.512 2.709.358c0 0 .768 1.024-.128 2.816l-.384.896s.256.256.256.768c0 .256-.128.64-.128.64s.128.128.256.384c.373.747.587 1.493.64 2.304.054.853-.16 1.621-.64 2.304-.373.512-.725 1.067-1.109 1.579-.32.469-.64.896-.896 1.344a7.721 7.721 0 0 1-1.067 1.579c-.192.213-.405.469-.619.661-.192.171-.469.427-.853.64-.576.32-1.13.576-1.643.747a9.772 9.772 0 0 1-1.493.384 5.36 5.36 0 0 1-.939.043c-.32 0-.619-.021-.939-.043a8.762 8.762 0 0 1-1.493-.384c-.533-.171-1.067-.427-1.643-.747-.384-.213-.661-.469-.853-.64a4.86 4.86 0 0 1-.619-.661c-.427-.491-.768-1.024-1.067-1.579a14.19 14.19 0 0 1-.896-1.344 14.717 14.717 0 0 1-1.109-1.579c-.48-.683-.693-1.472-.64-2.304.053-.811.267-1.557.64-2.304.128-.256.256-.384.256-.384s-.128-.384-.128-.64c0-.512.256-.768.256-.768l-.384-.896c-.896-1.792-.128-2.816-.128-2.816.853-.853 2.709-.358 2.709-.358L8.32 0h1.963l1.579.981L12.843 0l1.301.299h1.536z" />
    </svg>
  );
};
